import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {Grid as MuiGrid} from "@mui/material"

export const StyledGridContent = styled(MuiGrid)`
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.gutter.backgroundColor};

    @media (min-width: ${breakpoints.values.md}px) {
        display: flex;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        width: 100vw;
        margin: auto;
        pointer-events: initial;
    }
`
